import {jsonMember, jsonObject} from "typedjson";

/** */

@jsonObject
export class PitActivityEntityInvertLink {

  @jsonMember({name: "masterEntityCode", constructor: String, emitDefaultValue: false, isRequired: false })
  private _masterEntityCode: string;

  @jsonMember({name: "masterEntityId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _masterEntityId: number;

  @jsonMember({name: "masterEntityName", constructor: String, emitDefaultValue: false, isRequired: false })
  private _masterEntityName: string;

  @jsonMember({name: "masterEntityTypeId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _masterEntityTypeId: number;

  @jsonMember({name: "description", constructor: String, emitDefaultValue: false, isRequired: false })
  private _description: string;

  @jsonMember({name: "entityLinkId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _entityLinkId: number;

  @jsonMember({name: "linkTypeId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _linkTypeId: number;

  get masterEntityCode(): string {
    return this._masterEntityCode;
  }

  set masterEntityCode(value: string) {
    this._masterEntityCode = value;
  }

  get masterEntityId(): number {
    return this._masterEntityId;
  }

  set masterEntityId(value: number) {
    this._masterEntityId = value;
  }

  get masterEntityName(): string {
    return this._masterEntityName;
  }

  set masterEntityName(value: string) {
    this._masterEntityName = value;
  }

  get masterEntityTypeId(): number {
    return this._masterEntityTypeId;
  }

  set masterEntityTypeId(value: number) {
    this._masterEntityTypeId = value;
  }

  get description(): string {
    return this._description;
  }

  set description(value: string) {
    this._description = value;
  }

  get entityLinkId(): number {
    return this._entityLinkId;
  }

  set entityLinkId(value: number) {
    this._entityLinkId = value;
  }

  get linkTypeId(): number {
    return this._linkTypeId;
  }

  set linkTypeId(value: number) {
    this._linkTypeId = value;
  }
}
